// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__gwFcI","title":"BackImages_title__2X-CI","images":"BackImages_images__3AafS"};